import { Card, Typography } from 'antd';
import * as echarts from 'echarts';
import React, { useEffect, useRef } from 'react';

const { Title } = Typography;

const ALARM_CATEGORIES = [
  { name: '活性炭滤芯', value: 0 },
  { name: 'PP棉', value: 0 },
  { name: '超滤膜', value: 0 },
  { name: '剩余时间', value: 0 },
  { name: '剩余流量', value: 0 },
  { name: '断连报警', value: 0 },
];

const AlarmStatistics: React.FC = () => {
  const chartRef = useRef<HTMLDivElement>(null);
  const chartInstance = useRef<echarts.ECharts | null>(null);

  useEffect(() => {
    if (!chartRef.current) return;

    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }

    const option: echarts.EChartsOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '15%',
        top: '8%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: ALARM_CATEGORIES.map((item) => item.name),
        axisLabel: {
          interval: 0,
          rotate: 30,
          fontSize: 11,
        },
        axisTick: {
          show: false,
        },
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
      },
      series: [
        {
          type: 'bar',
          data: ALARM_CATEGORIES.map((item) => ({
            value: item.value,
            itemStyle: {
              color: '#4A90E2',
              borderRadius: [4, 4, 0, 0],
            },
          })),
          barWidth: '40%',
          label: {
            show: true,
            position: 'top',
            fontSize: 11,
          },
        },
      ],
    };

    chartInstance.current.setOption(option);

    const handleResize = () => {
      chartInstance.current?.resize();
    };
    window.addEventListener('resize', handleResize);

    const resizeObserver = new ResizeObserver(() => {
      chartInstance.current?.resize();
    });
    if (chartRef.current) {
      resizeObserver.observe(chartRef.current);
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <Card
      style={{ height: '100%', width: '100%' }}
      title={
        <Title style={{ marginTop: '20px', fontSize: '16px' }} level={3}>
          报警统计
        </Title>
      }
    >
      <div ref={chartRef} style={{ width: '100%', height: '280px' }} />
    </Card>
  );
};

export default AlarmStatistics;
